import React, { useContext } from 'react';

import { NotificationsApi } from '../apis';
import { api } from '../api';

const NotificationsApiContext = React.createContext(new NotificationsApi(api));

export const NotificationsApiProvider = NotificationsApiContext.Provider;
export const useNotificationsApi = (): NotificationsApi => useContext(NotificationsApiContext);

